import React from "react";
import { StyledSidebarCircle } from "./styled";

export default function SidebarCircle({ children }) {
  return <StyledSidebarCircle>{children}</StyledSidebarCircle>;
}
